import { useContext } from "react";
import "./CheckOut.css";
import { stateType } from "../../store";
import { connect } from "react-redux";
import { setCheckOutError, setPageCount } from "../../state_management/actions";
import Button from "../../UI/Button/Button";
import ButtonPlane from "../../UI/Button/ButtonPlane";
import {
  disableSection,
  isComplete,
  orderType,
  proceed_val_type,
  section_array
} from "../../state_management/reducers/order";
import { settings } from "../../state_management/actionTypes";
import { cartInitialState } from "../../state_management/reducers/cart";
import { only_gift } from "../../utilities/cartUtilities";
import { CartTotalContext, LocaleContext } from "../../AppProvider";
import { useNavigate } from "react-router-dom";
import { baseName } from "../../settings";
import { scrollToTimeBlock } from "../../elements/CheckOutTime/CheckOutTime";

const CheckOutButtons = ({
  // External
  loading,
  disabled,
  isLarge,
  nextFunction,
  // Connected
  pageCount,
  setPageCount,
  orderDetails,
  orderDirect,
  orderSuccess,
  settings,
  setCheckOutError,
  addressBlacklisted,
  cart
}: {
  // External
  loading?: boolean;
  disabled?: boolean;
  isLarge?: boolean;
  nextFunction?: () => void;
  // Connected
  pageCount: proceed_val_type;
  setPageCount: (data: number) => void;
  orderDetails: orderType;
  orderDirect: boolean;
  orderSuccess: boolean;
  settings: Partial<settings>;
  setCheckOutError: (data: boolean) => void;
  addressBlacklisted: boolean;
  cart: cartInitialState;
}) => {
  const minimum_order = settings.minimum_order;
  const onlyGift = only_gift(cart);
  const { t } = useContext(LocaleContext);
  const [cartTotal] = useContext(CartTotalContext);
  const navigate = useNavigate();

  const forwardOnly = pageCount === 0;
  const ignoreDetails = orderDirect || orderSuccess;
  const blacklisted = addressBlacklisted;
  const proceed = blacklisted
    ? false
    : isComplete(pageCount, orderDetails, ignoreDetails, onlyGift);

  const isBelowMinAmount =
    cartTotal === null ||
    cartTotal === undefined ||
    minimum_order === undefined ||
    minimum_order > cartTotal;

  const disabledButton = onlyGift
    ? false
    : isBelowMinAmount || !!loading || blacklisted || !!disabled;

  return (
    <div
      className={`check_list_btn_wrapper ${
        isLarge ? "" : "showSm floatCheckoutButton"
      } ${forwardOnly ? "forward_only_button" : ""}`}
    >
      {!forwardOnly ? (
        <div className="check_list_btn_inner flex">
          <ButtonPlane
            onClick={() => {
              // If on Address step (page 3), going back should skip Login (page 2) and go to Time (page 1)
              if (pageCount === 3) {
                setPageCount(1);
                return;
              }
              const new_page = (pageCount - 1) as proceed_val_type;
              const ds = disableSection(new_page as proceed_val_type, onlyGift);
              if (ds) {
                let new_page_index: number | undefined = undefined;
                section_array.forEach((num, ndx) => {
                  if (num === new_page) {
                    new_page_index = ndx;
                  }
                });

                // if it is assigned and greater than zero
                // I am doing this because we can move 2 steps back
                // if new_page is not the first page
                if (new_page_index) {
                  setPageCount(new_page_index - 1);
                }
              } else {
                setPageCount(pageCount - 1);
              }
            }}
            size="sm"
            span
          >
            {t("Back")}
          </ButtonPlane>
        </div>
      ) : (
        ``
      )}
      <div className="check_list_btn_inner flex">
        <Button
          onClick={() => {
            if (loading) {
              return;
            }
            if (nextFunction) {
              nextFunction();
            } else {
              if (proceed) {
                setPageCount(pageCount + 1);
              } else {
                setCheckOutError(true);
                if (pageCount === 1 && !orderDetails.time_start) {
                  scrollToTimeBlock();
                }
              }
            }
          }}
          size="sm"
          span
          disabled={disabledButton}
        >
          {loading ? t("Loading...") : t("Next Step")}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  pageCount: state.commonReducer.pageCount,
  cart: state.cartReducer,
  orderDetails: state.orderReducer.details,
  orderDirect: state.orderReducer.direct,
  orderSuccess: state.orderReducer.success,
  settings: state.settingsReducer,
  addressBlacklisted: state.commonReloadReducer.addressBlacklisted
});

const mapDispatchToProps = (dispatch: any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  },
  setCheckOutError: (data: boolean) => {
    dispatch(setCheckOutError(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutButtons);
